// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSegmentsUpdateTagsResult = objectOf({
  info: string,
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
  undo_identifier: maybe(string),
  undo_data: maybe(
    objectOf({
      app_group_id: string,
      desired_state: recordOf({
        key: string,
        value: arrayOf(string),
      }),
    })
  ),
});
